import React, { useEffect } from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { map } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { renderRiskContext } from 'components/DataDisplay';
import { DetailsField } from 'components/DataDisplay/Utils/DetailsField';
import { ServicesIcon } from 'components/Icons';
import { useMetadataDrawerTabs } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/hooks/useMetadataDrawerTabs';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';
import { useActiveResourceActions } from 'containers/ActiveCloudResource/hooks/useActiveResourceActions';
import { MetadataTabs } from 'containers/ActiveCloudResource/types';
import { CloudAccountName } from 'containers/Setup/CloudAccounts/utils';
import { selectSharedState } from 'containers/SharedState/selectors';
import { actions } from 'containers/SharedState/slice';
import { SidebarAccordion } from 'containers/Visibility/SecurityGraphNext/Components/SidebarAccordion';
import { useSearchResult } from 'containers/Visibility/SecurityGraphNext/hooks/useSearchResult';
import { selectSecurityGraphNext } from 'containers/Visibility/SecurityGraphNext/selectors';

export const Details = () => {
  const { mapType } = useSelector(selectSecurityGraphNext);
  const { riskContext, alertCount, resourceInsight } = useSelector(
    selectSharedState,
  );
  const { selectedSourceNodeOption } = useSelector(selectSecurityGraphNext);
  const { value: entity } = selectedSourceNodeOption ?? {};
  const { searchResult } = useSearchResult();
  const dispatch = useDispatch();
  const { onOpenMetadata } = useActiveResourceContext();
  const { updateActiveResource } = useActiveResourceActions();
  const { getTabIndex } = useMetadataDrawerTabs();

  useEffect(() => {
    if (!!entity?.environment_id) {
      dispatch(
        actions.getAlertCount({
          q: {
            environmentId: entity?.environment_id,
            accountIds: [entity?.account],
            resourceUuids: entity?.uuid,
          },
        }),
      );
      dispatch(
        actions.getResourceInsight({
          q: { insightV2Request: { resource_uuids: [entity?.uuid] } },
        }),
      );
    }
  }, [dispatch, entity]);

  return (
    <Stack spacing={3}>
      <SidebarAccordion
        header={'DETAILS'}
        icon={<ServicesIcon color="primary" />}
      >
        <Stack spacing={4}>
          <DetailsField
            label="Name"
            value={entity?.name}
            showValueOverflow={false}
            showTooltip
            isLoading={resourceInsight.isLoading || searchResult.isLoading}
          />
          <DetailsField
            label="Cloud ID"
            value={entity?.resource_id}
            showValueOverflow={false}
            showTooltip
            isLoading={resourceInsight.isLoading || searchResult.isLoading}
          />
          <DetailsField
            label="Account"
            value={<CloudAccountName accountId={entity?.account ?? ''} />}
            showValueOverflow={false}
            isLoading={resourceInsight.isLoading || searchResult.isLoading}
          />
          {mapType === 'posture' && (
            <>
              <DetailsField
                label="Region"
                value={entity?.region}
                showValueOverflow={false}
                showTooltip
                isLoading={resourceInsight.isLoading || searchResult.isLoading}
              />
              <DetailsField
                label="VPC"
                value={
                  resourceInsight.data?.vpc ?? resourceInsight?.data?.vpc?.id
                }
                isLoading={resourceInsight.isLoading || searchResult.isLoading}
                showValueOverflow={false}
                showTooltip
              />
            </>
          )}
          <DetailsField
            label="Alerts"
            isLoading={alertCount.isLoading || searchResult.isLoading}
            value={
              <Box
                color="primary"
                cursor="pointer"
                onClick={() => {
                  updateActiveResource({
                    resourceType: entity?.native_name,
                    uuid: entity?.uuid,
                    accountId: entity?.account,
                    resourceId: entity?.resource_id,
                  });
                  onOpenMetadata(
                    getTabIndex(entity?.native_name, MetadataTabs.Alerts),
                  );
                }}
              >
                {alertCount.data?.[entity?.uuid] ?? 0}
              </Box>
            }
          />
          <DetailsField
            label="Risk Context"
            isLoading={riskContext?.isLoading || searchResult.isLoading}
            value={renderRiskContext(riskContext.data?.[entity?.uuid])}
          />
          {/*<DetailsField
            label="Environment"
            value={environmentMapping?.[entity?.environment_id]?.name ?? ''}
            showValueOverflow={false}
            showTooltip
          />*/}
        </Stack>
      </SidebarAccordion>
    </Stack>
  );
};
